import React from "react";
import "./About.scss";
import { motion } from "framer-motion";
import { bios } from "../../../Data";
import portfolio from "../../../assets/portfolio.jpg";
import CV from "../../../assets/UtkarshGoel.pdf"
const About = () => {
  return (
    <div className="container " id="about">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ y: [-50, 0], opacity: 1 }}
        className="title"
      >
        <span>Who Am I?</span>
        <h1>About Me</h1>
      </motion.div>

      <div className="about_container">
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [150, 0], opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="about_left"
        >
          <motion.img
            src={portfolio}
            style={{cursor: 'crosshair'}}
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.3 },
            }}
            whileTap={{ scale: 0.8 }}
            whileInView={{ opacity: 1 }}
          />
        </motion.div>
        <motion.div
          className="about_right"
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [150, 0], opacity: 1 }}
          transition={{ duration: 0.8 }}
        >          
          <p>
            I'm a final year student currently pursuing my bachelor's of
            technology. I'm a tech enthusiast, and an avid learner. I'm also an
            instructor, helping developers become confident in their domains.
            I've trained more than 150 students in web development domain.
            I make programming tutorials on Youtube occasionally. I'm
            searching for new opportunities; if you believe I may be of
            assistance, feel free to contact me.
          </p>
          {bios.map((bio) => {
            return (
              <div className="bio" key={bio.id}>
                <span className="bioKey">
                  {bio.icon}
                  {bio.key}
                </span>
                <span className="bioValue">{bio.value}</span>
              </div>
            );
          })}
          <motion.a
            href={CV}
            download
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.3 }}
          >
            Download Resume
          </motion.a>
        </motion.div>
      </div>
    </div>
  );
};

export default About;
